import React from 'react';
import PropTypes from 'prop-types';

const RouterV2 = ({ fill = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 17.5C16.3807 17.5 17.5 16.3807 17.5 15C17.5 13.6193 16.3807 12.5 15 12.5C13.6193 12.5 12.5 13.6193 12.5 15C12.5 16.3807 13.6193 17.5 15 17.5Z"
      stroke="#6B6C7B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      d="M5 7.5C6.38071 7.5 7.5 6.38071 7.5 5C7.5 3.61929 6.38071 2.5 5 2.5C3.61929 2.5 2.5 3.61929 2.5 5C2.5 6.38071 3.61929 7.5 5 7.5Z"
      stroke="#6B6C7B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      d="M10.8335 5H13.3335C13.7755 5 14.1994 5.17559 14.512 5.48816C14.8246 5.80072 15.0002 6.22464 15.0002 6.66667V12.5"
      stroke="#6B6C7B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      d="M9.16667 15H6.66667C6.22464 15 5.80072 14.8244 5.48816 14.5118C5.17559 14.1993 5 13.7754 5 13.3333V7.5"
      stroke="#6B6C7B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);
RouterV2.propTypes = {
  fill: PropTypes.string,
};

export default RouterV2;
